<template>
  <div class="q-pa-md q-gutter-sm">
    <q-toolbar class="shadow-2 rounded-borders">
      <q-toolbar-title>
        AÑO
      </q-toolbar-title>
      <q-select outlined
                dense
                v-model="year"
                :options="years()"
                @update:model-value="updateData()">
      </q-select>
      <q-space></q-space>
      <q-toolbar-title>
        MES
      </q-toolbar-title>
      <q-select outlined
                dense
                v-model="month"
                :options="months()"
                @update:model-value="updateData()">
      </q-select>
    </q-toolbar>
    <q-list bordered
            class="rounded-borders">
      <q-expansion-item expand-separator
                        icon="euro"
                        switch-toggle-side
                        label="Valls">
        <template v-slot:header>
          <q-item-section>
            Valls
          </q-item-section>
          <q-item-section center>
            <div class="row items-center">
              <q-chip v-bind="chipProps.green"
                      icon="euro">
                {{ altasVallsA }}
              </q-chip>
              <q-chip v-bind="chipProps.red"
                      icon="euro">
                {{ bajasVallsA }}
              </q-chip>
            </div>
          </q-item-section>
          <q-item-section side>
            <div class="row items-center">
              <q-chip v-bind="chipProps.green"
                      icon="euro">
                {{ altasValls }}
              </q-chip>
              <q-chip v-bind="chipProps.red"
                      icon="euro">
                {{ bajasValls }}
              </q-chip>
            </div>
          </q-item-section>
        </template>
        <q-card>
          <q-card-section>
            <highcharts :options="chartValls"
                        style="height: 60vh">
            </highcharts>
          </q-card-section>
        </q-card>
      </q-expansion-item>
      <q-expansion-item expand-separator
                        icon="euro"
                        switch-toggle-side
                        label="Reus">
        <template v-slot:header>
          <q-item-section>
            Reus
          </q-item-section>
          <q-item-section center>
            <div class="row items-center">
              <q-chip v-bind="chipProps.green"
                      icon="euro">
                {{ altasReusA }}
              </q-chip>
              <q-chip v-bind="chipProps.red"
                      icon="euro">
                {{ bajasReusA }}
              </q-chip>
            </div>
          </q-item-section>
          <q-item-section side>
            <div class="row items-center">
              <q-chip v-bind="chipProps.green"
                      icon="euro">
                {{ altasReus }}
              </q-chip>
              <q-chip v-bind="chipProps.red"
                      icon="euro">
                {{ bajasReus }}
              </q-chip>
            </div>
          </q-item-section>
        </template>
        <q-card>
          <q-card-section>
            <highcharts :options="chartReus"
                        style="height: 60vh">
            </highcharts>
          </q-card-section>
        </q-card>
      </q-expansion-item>
    </q-list>
  </div>
</template>

<script setup>
import { onMounted, ref, inject } from "vue"
const global = inject("global")
const series = ref({});
const years = () => Array.from({ length: 5 }, (_, i) => new Date().getFullYear() - i);
const year = ref(new Date().getFullYear());
const months = () => [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
const month = ref(String(new Date().getMonth() + 1));
const altasValls = ref()
const altasVallsA = ref()
const bajasValls = ref()
const bajasVallsA = ref()
const altasReus = ref()
const altasReusA = ref()
const bajasReus = ref()
const bajasReusA = ref()
const chartValls = ref()
const chartReus = ref()

const chipProps = {
  green: { square: true, color: "green", "text-color": "white" },
  red: { square: true, color: "red", "text-color": "white" }
};

// FUNCTION CHARTS
const chartOptions = (title, dataNP, dataAN) => ({
  accessibility: { enabled: false },
  title: { text: title },
  chart: { type: "column", zoomType: "xy" },
  xAxis: {
    title: { text: "Meses" },
    categories: [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre",
    ],
    crosshair: true,
  },
  yAxis: { min: 0, title: { text: "Euros" } },
  tooltip: { valueSuffix: " (€)", valueDecimals: 0 },
  plotOptions: {
    column: {
      pointPadding: 0.2,
      borderWidth: 0,
      dataLabels: { enabled: true, format: "{point.y:.0f}" },
    },
  },
  credits: {
    enabled: false,
  },
  series: [
    {
      name: "Nueva Producción",
      data: dataNP,
      color: "#4caf50",
    },
    {
      name: "Anulaciones",
      data: dataAN,
      color: "#f44336",
    },
  ],
});

chartValls.value = chartOptions("Valls", series.value.NPV, series.value.ANV);
chartReus.value = chartOptions("Reus", series.value.NPR, series.value.ANR);

async function updateData() {
  const queries = ["NegAltas", "NegBajas"];
  const data = queries.map(query => ({ query: query, table: "Polizas", where: { year: year.value } }));
  const res = await global.db("/app/db/selNegocio", data);

  res.forEach((item, i) => {
    if (item.success) {
      updateLocationData(item.data, i, "Valls", 34764);
      updateLocationData(item.data, i, "Reus", 42886);
    }
  });
}

function updateLocationData(data, i, location, mediadorId) {
  const chart = location === "Valls" ? chartValls : chartReus;
  const altas = location === "Valls" ? altasValls : altasReus;
  const altasA = location === "Valls" ? altasVallsA : altasReusA;
  const bajas = location === "Valls" ? bajasValls : bajasReus;
  const bajasA = location === "Valls" ? bajasVallsA : bajasReusA;

  const med = global.data.getRows(data, "Mediador", mediadorId);
  chart.value.series[i].data = global.data.getColumn(med, "Importe");

  if (i === 0) {
    altas.value = global.data
      .get(med, "Mes", Number(month.value), "Importe")
      .toLocaleString("es-ES", { maximumFractionDigits: 0 });
    altasA.value = global.data
      .getSum(med, "Importe")
      .toLocaleString("es-ES", { maximumFractionDigits: 0 });
  }

  if (i === 1) {
    bajas.value =
      global.data
        .get(med, "Mes", Number(month.value), "Importe")
        ?.toLocaleString("es-ES", { maximumFractionDigits: 0 }) || "0";
    bajasA.value =
      global.data
        .getSum(med, "Importe")
        ?.toLocaleString("es-ES", { maximumFractionDigits: 0 }) || "0";
  }
}

onMounted(() => {
  updateData();
})
</script>